module.exports = __webpack_public_path__ + "static/media/domain_logo_Egypt.d3c46b90.svg";